import { amountToDisplayValue, Badge, Text } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { UmbrellaOrganizationTable } from '../../../../../../../umbrella/routes/umbrellaOrganizations/types/umbrellaOrganizationTable'
import { getPlanName } from '../../utils/getPlanName'

interface SubscriptionCellProps {
  umbrellaOrganization: UmbrellaOrganizationTable
}

export const SubscriptionCell = ({ umbrellaOrganization }: SubscriptionCellProps): ReactElement => {
  const { t } = useTranslation()
  const { consolidatedBilling, isTerminated, subscriptionPrice, subscriptionProductPlan, subscriptionPeriod } =
    umbrellaOrganization

  const subscriptionPlanName = getPlanName(subscriptionProductPlan, t) || null

  let badge
  if (isTerminated) {
    badge = (
      <Badge color="danger" mode="subtle">
        {t('umbrella_organizations.organizations_table.terminated')}
      </Badge>
    )
  } else if (consolidatedBilling) {
    badge = (
      <Badge color="accent" mode="subtle">
        {t('umbrella_organizations.organizations_table.consolidated_billing')}
      </Badge>
    )
  } else {
    badge = (
      <Badge color="success" mode="subtle">
        {t('umbrella_organizations.organizations_table.self_paying')}
      </Badge>
    )
  }

  return (
    <>
      <Text>{subscriptionPlanName}</Text>
      {subscriptionPrice && (
        <Text variant="bodySM" colorVariant="secondary">
          {amountToDisplayValue(subscriptionPrice, false, 'DKK')}/
          {subscriptionPeriod === 'yearly' ? t('year') : t('month')}
        </Text>
      )}
      {badge}
    </>
  )
}
